export const PRESENCE_EVENTS = {
  WATCH: 'presence:watch',
  JOIN_CONSULT: 'presence:join-consult',
  HEARTBEAT: 'presence:heartbeat',
  LEAVE_CONSULT: 'presence:leave-consult',
  SNAPSHOT: 'presence:snapshot',
  UPDATED: 'presence:updated',
  ERROR: 'presence:error',
} as const;

export const HEARTBEAT_INTERVAL_MS = 25_000;
